import React from 'react';
import ReferenceTextModal from '../Modal/reference-text-modal';
import {
  OpenModalButton,
  ModalPanel,
  CloseModalButton,
} from '../Modal/reference-text-modal';

const ReferenceToolTip = (props) => {
  if (typeof window === 'undefined') return;

  const translations = window.__PRELOADED_STATE__.Content.Translations;

  return (
    <span className="reference">
      <ReferenceTextModal>
        <OpenModalButton
          open={`reference-${props.componentId}`}
          id={`reference-${props.componentId}`}
          className={'reference__modal-element reference__modal-open'}
        >
          {props.label}
        </OpenModalButton>
        <ModalPanel whenActive={`reference-${props.componentId}`}>
          <span
            className={`reference__modal-panel reference__modal-element reference-${props.componentId} `}
            tabIndex={0}
          >
            <span
              className="reference__modal-panel__item reference__modal-element"
              dangerouslySetInnerHTML={{
                __html: props.referenceText,
              }}
            ></span>
            <CloseModalButton id={'reference' + props.componentId}>
              <span className="show-for-sr">{translations.close}</span>
            </CloseModalButton>
          </span>
        </ModalPanel>
      </ReferenceTextModal>
    </span>
  );
};
export default ReferenceToolTip;
